export default __webpack_public_path__ + "static/media/postgresqlfront.7b7d1d31.svg";